export const NO_MEAL_NAME = "Meal name not found!";
/**
 *
 * @param meals Day group meals are listed individually.
 * @param programMealDictionary A meal lookup to correlate meal names with meal ids.
 * @returns The combined meals.
 */
export const combineLikeMeals = (meals, programMealDictionary) => {
    const combinedMeals = {};
    meals === null || meals === void 0 ? void 0 : meals.forEach((meal) => {
        var _a, _b;
        const mealKey = meal.programMealId;
        if (combinedMeals[mealKey]) {
            combinedMeals[mealKey].discountedCost += meal.discountedCost;
            combinedMeals[mealKey].totalCost += meal.totalCost;
            combinedMeals[mealKey].quantity++;
        }
        else {
            combinedMeals[mealKey] = {
                programMealId: meal.programMealId,
                mealName: (_b = (_a = programMealDictionary === null || programMealDictionary === void 0 ? void 0 : programMealDictionary[meal.programMealId]) === null || _a === void 0 ? void 0 : _a.mealName) !== null && _b !== void 0 ? _b : NO_MEAL_NAME,
                discountedCost: meal.discountedCost,
                totalCost: meal.totalCost,
                quantity: 1, // initial value
            };
        }
    });
    return Object.values(combinedMeals);
};
